import { shouldSearchByHashtag } from '../services/search-utils';
import { extractHashtagsFromText } from '@wix/communities-forum-client-commons/dist/src/services/hashtag-utils';
import uri from '@wix/communities-forum-client-commons/dist/src/services/urijs';
import { createPromisifiedAction } from '../../common/actions-promisifier/create-promisified-action';
import {
  ApiMetadata,
  CommonRequest,
  SearchResultComment,
  SearchResultPost,
  SearchSuggestionsData,
} from '../types';

type SearchData = {
  metadata: ApiMetadata;
  posts: (SearchResultPost | SearchResultComment)[];
};

export const fetchSearchSuggestionsPromisified = createPromisifiedAction(
  (query: string, limit: number) => {
    return (
      _dispatch: any,
      _getState: any,
      { request }: { request: CommonRequest },
    ): Promise<SearchSuggestionsData> => {
      const pagination = {
        size: limit,
        offset: 0,
      };

      const path = shouldSearchByHashtag(query)
        ? uri('/search/hashtags', '').query({
            q: extractHashtagsFromText(query).join(','),
            ...pagination,
          })
        : uri('/search', '').query({ q: encodeURIComponent(query), ...pagination });

      return request<SearchData>(path).then(forumSearchData => {
        return {
          query,
          forumSearchData: {
            entities: forumSearchData.posts,
            totalCount: forumSearchData.metadata.total,
          },
        };
      });
    };
  },
  ((data: SearchSuggestionsData) => data) as any,
);
